import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../../Modules/Acl/Components/AclContextProvider';
import WorkplaceFormOfCarePHP from './WorkplaceFormOfCarePHP';

loadDOMComponent({
	selector: 'react-workplace-form-of-care',
	callback: ({ container, context, props }: any) => {
		const name = container.getAttribute('name');
		const placeholder = container.getAttribute('placeholder');
		const value = container.getAttribute('value');
		const netteRules = container.getAttribute('data-nette-rules');
		let required = container.getAttribute('required');
		required = required !== false && required !== null;

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<WorkplaceFormOfCarePHP
							name={name}
							value={value}
							data-nette-rules={netteRules}
							placeholder={placeholder}
							isRequired={required}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
